import camelCase from '../lib/camelCase'
import Immutable from 'immutable'

function transformServicesFromApi(payload) {
    return camelCase(payload);
}

export function get(api, params) {
    let servicesUrl = params?.region ? `services?region=${params.region}` : 'services';
    return api.get(api.url(servicesUrl), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformServicesFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};
